import React from "react";
import styles from "./cn-converter-welcome.module.scss";
import { useNavigate } from "react-router-dom";
import { constRoute } from "@utils/route";
import style from "@components/pages/project/project-name/style.module.scss";
import GoBack from "@commonComponents/go-back";

const GradeWelcome = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.welcomeModal}>
        <div className={styles.welcomeModalContent}>
          <h1 className={styles.welcomeModalTitle}>
            Welcome to the Concept Note Evaluator!
          </h1>
          <p className={styles.welcomeModalDesc}>
            This Assistant is designed to evaluate your GCF Concept Note against
            the updated GCF criteria and guidelines for Concept Notes (version
            3.0).
          </p>
          <p className={styles.welcomeModalDesc}>
            <strong>Concept Note Length:</strong> This Assistant is optimized
            for Concept Notes (CNs) under 30 pages. If your CN exceeds this
            length, please expect longer processing times, particularly for the
            initial section.
          </p>
          <p className={styles.welcomeModalDesc}>
            <strong>Processing times:</strong> Selecting multiple Result Areas
            (sectors) requires a comprehensive review of all relevant sector
            guides and other GCF guidance. Please allow approximately 90 seconds
            for the report to be generated.
          </p>
          {/* <p className={styles.welcomeModalDesc}>
            <strong>Editing Recommendations:</strong> At the end of each output,
            you will find a list of suggestions for text condensation/deletions
            that will help you to not exceed the word count limits. Only adopt
            these if the subject narrative exceeds the prescribed word count
            limit.
          </p> */}
          <p className={styles.welcomeModalDesc}>
            <strong>Important:</strong> While Generative Language Models provide
            unprecedented efficiency and precision, they are not perfect. Always
            verify crucial information. The author(s) bear ultimate
            responsibility for the Concept Note's accuracy.
          </p>
          <p className={styles.welcomeModalGreetings}>
            <em>Warm regards, The Janus Team</em>
          </p>
        </div>
        <div
          className={styles.welcomeModalButton}
          onClick={() => navigate(constRoute.projectName + "/evaluate-quick")}
        >
          Continue
        </div>
      </div>

      <div className={style.btnDiv}>
        <div className={style.twoBtnDiv}>
          <div className={style.goBackBtnDiv}>
            <GoBack
              onClick={constRoute?.selectFunction}
              className={style.goBtn}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GradeWelcome;
